module.exports = __webpack_public_path__ + "img/solution-lines.be506fcb.svg";